import { isEmpty, omit, without } from 'lodash';
import { ACTION_TYPES } from '../constants';
import { ACTION_TYPES as MESSAGES_ACTION_TYPES } from '../../messages/constants';

const tasksReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_TASKS_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_TASKS_INFINITE_LIST_NEXT_PAGE_SUCCESS:
    case ACTION_TYPES.GET_SECTION_TASKS_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_USER_TASKS_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_DASHBOARD_TASKS_REQUEST_SUCCESS:
    case ACTION_TYPES.SEARCH_TASKS_REQUEST_SUCCESS:
    case ACTION_TYPES.MERGE_CHART_PREVIEW_TASKS: {
    const updatedState = Object.values(action?.payload?.tasks || {}).reduce(
        (result, task) => ({
          ...result,
          [task?._id]: {
            ...(state[task?._id] || {}),
            ...(task || {}),
          },
        }),
        {},
      );
      return {
        ...state,
        ...(updatedState || {}),
      };
    }
    case ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST: {
      if (!action?.payload?.taskId) return state;

      return {
        ...state,
        [action?.payload?.taskId]: {
          ...(state?.[action?.payload?.taskId] || {}),
          isLoading: true
        },
      };
    }
    case ACTION_TYPES.GET_TASK_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_TASK_BY_IDENTIFIER_LEAN_REQUEST_SUCCESS:
    case ACTION_TYPES.EDIT_TASK_REVERT:
    case ACTION_TYPES.ADD_TASK_EVENT: {
      const subtasks = action?.payload?.subtasks || {};

      const updatedStateForSubtasks = {};

      Object.keys(subtasks).forEach(subtaskId => {
        const dataFromAction = subtasks[subtaskId] || {};
        const currentStateData = state[subtaskId] || {};

        updatedStateForSubtasks[subtaskId] = {
          ...currentStateData,
          ...dataFromAction
        }
      });

      return {
        ...state,
        ...updatedStateForSubtasks,
        [action?.payload?.taskId]: {
          ...(state?.[action?.payload?.taskId] || {}),
          ...(action?.payload?.task || {}),
          isLoading: false
        },
      };
    }
    case ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_ERROR: {
      if (!action?.payload?.taskId) return state;

      return {
        ...state,
        [action?.payload?.taskId]: {
          ...(state?.[action?.payload?.taskId] || {}),
          isLoading: false
        },
      };
    }
    case ACTION_TYPES.ADD_TASK_SUCCESS:
    case ACTION_TYPES.ADD_SUBTASK_EVENT: {
      const { parentTaskId } = action?.payload?.task || {};
      const taskId = action?.payload?.taskId;

      let updatedParentTaskState = {};
      if (parentTaskId) {
        const parentTask = state?.[parentTaskId] || {};
        const parentSubTaskOrder = parentTask?.subTaskOrder || [];
        const parentSubtasks = parentTask?.subtasks || [];
        updatedParentTaskState = {
          [parentTaskId]: {
            ...parentTask,
            subTaskOrder: parentSubTaskOrder.includes(taskId) ? parentSubTaskOrder: [...parentSubTaskOrder, taskId],
            subtasks: parentSubtasks.includes(taskId) ? parentSubtasks : [...parentSubtasks, taskId],
          }
        };
      }
      return {
        ...state,
        [action?.payload?.taskId]: {
          ...(state?.[action?.payload?.taskId] || {}),
          ...(action?.payload?.task || {}),
        },
        ...updatedParentTaskState
      };
    }
    case ACTION_TYPES.DELETE_TASK_REQUEST:
    case ACTION_TYPES.REMOVE_TASK_EVENT:
      const taskId = action?.payload?.taskId;
      const task = state?.[taskId] || {};

      const updatedState = omit(state, taskId);

      if (!task?.parentTaskId) {
        return updatedState;
      }
      
      const parentTask = state?.[task?.parentTaskId];

      return {
        ...state,
        [parentTask?._id]: {
          ...(state?.[parentTask?._id] || {}),
          subTaskOrder: parentTask?.subTaskOrder?.filter(subtaskId => subtaskId !== taskId),
          subtasks: parentTask?.subtasks?.filter(subtaskId => subtaskId !== taskId)
        }
      };
    case ACTION_TYPES.EDIT_TASK: {
      const taskId = action?.payload?.taskId;
      const updatedPart = { ...(action?.payload?.dataToUpdate || {}) };
      if (!isEmpty(updatedPart?.assignee)) {
        updatedPart.assignee = updatedPart?.assignee?.map((assignee) => assignee?.assigneeId?._id);
      }

      const task = state?.[taskId] || {};
      const parentTask = state?.[task?.parentTaskId];

      return {
        ...state,
        [taskId]: {
          ...(state?.[taskId] || {}),
          ...(updatedPart || {}),
        }
      };
    }
    case ACTION_TYPES.EDIT_TASK_CUSTOM_FIELD: {
      const { taskId, customFieldId, customFieldValue } = action?.payload;

      const currentTask = state?.[taskId] || {};

      return {
        ...state,
        [taskId]: {
          ...currentTask,
          extendedCustomFields: currentTask?.extendedCustomFields?.map(field => {
            if (field?._id !== customFieldId) {
              return field;
            }

            return {
              ...field,
              value: customFieldValue
            }
          }),
          customFields: currentTask?.customFields?.map(field => {
            if (field?._id !== customFieldId) {
              return field;
            }

            return {
              ...field,
              value: customFieldValue
            }
          })
        },
      };
    }
    case ACTION_TYPES.ADD_COMMENT_TO_TASK: {
      const comment = action.payload;
      const taskId = comment?.taskId;

      if (isEmpty(state[taskId])) {
        return state;
      }

      const commentIndex = state[taskId]?.comments?.findIndex((taskComment) => taskComment._id === comment?._id);
      const hasCommentWithSameId = commentIndex > -1;
      const currentTotalComments = state[taskId]?.totalComments || 0;
      const currentComments = state[taskId]?.comments || [];
      return {
        ...state,
        [taskId]: {
          ...(state[taskId] || {}),
          totalComments:
            isEmpty(state[taskId]?.comments) || !hasCommentWithSameId ? currentTotalComments + 1 : currentTotalComments,
          comments: hasCommentWithSameId
            ? currentComments.map((item, idx) => (idx === commentIndex ? comment : item))
            : [...currentComments, comment],
        },
      };
    }
    case ACTION_TYPES.DELETE_COMMENT_FROM_TASK: {
      const messageId = action.payload?.messageId;
      const taskId = action.payload?.taskId;

      if (isEmpty(state[taskId])) {
        return state;
      }

      const hasCommentWithSameId = (state[taskId]?.comments || []).includes(messageId);
      const currentTotalComments = state[taskId]?.totalComments || 0;
      const currentComments = state[taskId]?.comments || [];
      return {
        ...state,
        [taskId]: {
          ...(state[taskId] || {}),
          totalComments: hasCommentWithSameId ? Math.max(currentTotalComments - 1, 0) : currentTotalComments,
          comments: hasCommentWithSameId ? without(currentComments, messageId) : currentComments,
        },
      };
    }
    case ACTION_TYPES.UPDATE_TASK_EVENT: {
      const taskId = action?.payload?.taskId;

      return {
        ...state,
        [taskId]: {
          ...(state[taskId] || {}),
          ...(action?.payload?.task || {}),
        },
      };
    }
    case ACTION_TYPES.TASKS_REORDER_ACTION: {
      const {
        taskId,
        projectId,
        toSection,
        itemsToIncreasePositionByOne,
        newPosition
      } = action.payload;

      const { 1: currentProjectId } = window.location.pathname.split('/');

      if (currentProjectId !== projectId) {
        return state;
      }

      const currentTask = state?.[taskId];

      if (isEmpty(currentTask)) {
        return state;
      }

      const updatedPartOfState = {};

      itemsToIncreasePositionByOne.forEach((itemId) => {
        const item = state?.[itemId] || {};
        updatedPartOfState[itemId] = {
          ...item,
          position: item?.position + 1,
        };
      });

      updatedPartOfState[taskId] = {
        ...currentTask,
        position: newPosition,
        sectionId: toSection,
      };

      return {
        ...state,
        ...updatedPartOfState,
      };
    }
    // FIXME: [new tasks store] BE is messing order, commented action for now in order not to show jumping tasks
    // case ACTION_TYPES.TASKS_REORDER_EVENT: {
    //   const tasksToUpdate = action?.payload?.tasks || [];

    //   const updatedState = {};

    //   tasksToUpdate.forEach(task => {
    //     updatedState[task?.task] = {
    //       ...(state?.[task?.task] || {}),
    //       position: task?.position
    //     }
    //   })

    //   return {
    //     ...state,
    //     ...updatedState
    //   }
    // }
    case ACTION_TYPES.ADD_TASK_CUSTOM_FIELD_ACTION: {

      const { taskId, description, name, possibleValues, type, _id, projectId } = action?.payload;

      const task = state?.[taskId] || {};

      if (isEmpty(task)) {
        return state;
      }

      const newField = {
        description, name, possibleValues, type, _id, value: null
      }

      return {
        ...state,
        [taskId]: {
          ...task,
          customFields: [...(task?.customFields || []), newField],
          extendedCustomFields: [...(task?.extendedCustomFields || []), newField]
        }
      }
    }
    case ACTION_TYPES.UPDATE_TASK_CUSTOM_FIELD_ACTION: {
      const { taskId, description, name, possibleValues, type, _id } = action?.payload;

      const task = state?.[taskId] || {};

      if (isEmpty(task)) {
        return state;
      }

      return {
        ...state,
        [taskId]: {
          ...task,
          customFields: (task?.customFields || []).map(customField => {
            if (customField?._id !== _id) {
              return customField;
            }

            return {
              ...customField,
              description,
              name,
              possibleValues,
              type
            }
          }),
          extendedCustomFields: (task?.extendedCustomFields || []).map(extendedCustomField => {
            if (extendedCustomField?._id !== _id) {
              return extendedCustomField;
            }

            return {
              ...extendedCustomField,
              description,
              name,
              possibleValues,
              type
            }
          })
        }
      }
    }
    case ACTION_TYPES.DELETE_TASK_CUSTOM_FIELD_ACTION: {
      const { taskId, customFieldId } = action?.payload;

      const task = state?.[taskId] || {};

      if (isEmpty(task)) {
        return state;
      }

      return {
        ...state,
        [taskId]: {
          ...task,
          customFields: (task?.customFields || []).filter((field => field?._id !== customFieldId)),
          extendedCustomFields: (task?.extendedCustomFields || []).filter((field => field?._id !== customFieldId))
        }
      }
    }
    case ACTION_TYPES.REMOVE_PROJECT_FROM_TASK_SUCCESS: {
      const { customFieldsIdList, projectId, taskId } = action?.payload;

      const task = state?.[taskId] || {};

      if (isEmpty(task)) {
        return state;
      }

      let updatedProjectId = task?.projectId;
      let updatedSectionId = task?.sectionId;

      if (task?.projectId === projectId) {
        updatedProjectId = undefined;
        updatedSectionId = undefined;
      }

      return {
        ...state,
        [taskId]: {
          ...task,
          projectId: updatedProjectId,
          sectionId: updatedSectionId,
          extendedCustomFields: (task?.extendedCustomFields || []).filter(customField => !(customFieldsIdList || [])?.includes(customField?._id))
        }
      }
    }
    case MESSAGES_ACTION_TYPES.DELETE_COMMENT_SUCCESS: {
      const { messageId, taskId } = action?.payload;

      const task = state?.[taskId] || {};

      if (isEmpty(task)) {
        return state;
      }

      return {
        ...state,
        [taskId]: {
          ...task,
          comments: (task?.comments || []).filter((comment => comment?._id !== messageId)),
        }
      }
    }
    case ACTION_TYPES.ADD_TASK_TO_PROJECT_REQUEST_SUCCESS: {
      const { taskId, projectId, sectionId, position } = action.payload || {};

      const { 1: currentProjectId } = window.location.pathname.split('/');

      if (currentProjectId !== projectId) {
        return state;
      }

      const currentTaskState = state[taskId] || {};

      return {
        ...state,
        [taskId]: {
          ...currentTaskState,
          position,
        }
      }
    }
    default: {
      return state;
    }
  }
};

export default tasksReducer;
